<template>
  <div
    id="app"
    class="min-vh-100 d-flex flex-column justify-content-between align-items-center backGround fallback"
    :style="{ backgroundImage: `url('${template.backgroundUrl}')` }"
  >
    <nav id="header" class="w-100 container pt-3 pb-4 text-center">
      <a v-if="sso == 'show'" href="/#/Login" title="Logo">
        <img :src="template.logoUrl" :width="headerLogoWidth" />
      </a>
    </nav>

    <main class="w-100 row container justify-content-center">
      <SupportText
        v-if="sso == 'show'"
        class="col-12 col-lg-6 mt-5 mt-lg-0 pr-lg-5 d-flex flex-column justify-content-center align-items-center"
        :titles="template.homeTexts"
      />

      <div class="col-12 col-lg-6 d-flex justify-content-center align-items-center">
        <router-view></router-view>
      </div>
    </main>

    <footer
      style="display: flex; flex-direction: column; justify-content: center"
      class="container text-white text-center pl-lg-4"
    >
      <div v-if="template.showPoweredBy" class="py-5">
        <small>Powered by</small>

        <img
          class="ml-2"
          src="https://config.fanbase.com.br/prj/0/logo-white.png"
          alt="Logo Fanbase"
          width="75px"
        />
      </div>
    </footer>
    <PopUpByClientId
      v-model="isOpen"
      :message="config.sso && config.sso.title ? config.sso.title : null"
      :html="config.sso && config.sso.html ? config.sso.html : null"
      :gradient="config.sso && config.sso.bgGradient ? config.sso.bgGradient : null"
      :bgImg="config.sso && config.sso.bgImg ? config.sso.bgImg : null"
      :logo="
        config.sso && config.sso.logoUrl
          ? config.sso.logoUrl
          : 'https://config.fanbase.com.br/prj/0/logo.png'
      "
      :button-color="template.primaryBtn.bgColor"
      :button-text-color="template.primaryBtn.textColor"
      :button-text="config.sso && config.sso.btnText ? config.sso.btnText : $t('common.understood')"
    />
  </div>
</template>

<script>
import { cacheBuster } from 'fb-cache-buster-js'
/* State */
import { mapGetters, mapState } from 'vuex'

import PopUpByClientId from '@/components/PopUpByClientId.vue'

export default {
  name: 'App',
  components: { PopUpByClientId },
  data: () => ({
    subdomain: '',
    domain: '',
    isOpen: false,
  }),
  computed: {
    ...mapGetters(['headerLogoWidth']),
    ...mapState(['config', 'template', 'sso']),
  },
  async created() {
    await cacheBuster()

    this.getUrlParams()

    if (this.$store.state.subdomain) {
      this.subdomain = this.$store.state.subdomain
    }

    const host = window.location.host
    const parts = host.split('.')

    if (host.includes('localhost')) {
      this.subdomain = 'login-bahia'
      this.domain = 'fan-id'
    } else {
      this.subdomain = parts[0]
      this.domain = parts[1]
    }

    this.$store.commit('SET_SUBDOMAIN', this.subdomain)
    this.$store.commit('SET_DOMAIN', this.domain)

    await this.$store.dispatch('get_Template')
  },
  watch: {
    'config.sso'(newVal) {
      const allowedPaths = ['/', '/login']
      const currentPath = this.$route.path

      if (newVal) {
        this.isOpen = newVal.popUpLogin ? true : false
      }

      if (newVal && allowedPaths.includes(currentPath)) {
        this.handleSSO()
      }
    },
    'config.meta': {
      handler(newMeta) {
        if (newMeta && newMeta.title) {
          this.setMetaDataFromTemplate()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.isOpen = this.config.sso && this.config.sso.popUpLogin ? true : false
    this.setMetaDataFromTemplate()
  },
  methods: {
    getUrlParams() {
      let sso1 = this.$route.query.sso
      let sso2 = new URLSearchParams(window.location.search).get('sso')

      if (sso1) this.$store.commit('set_sso', sso1)
      if (sso2) this.$store.commit('set_sso', sso2)
    },
    handleSSO() {
      const allowedPaths = ['/', '/login']
      const currentPath = this.$route.path

      if (!allowedPaths.includes(currentPath)) {
        console.log('Rota não permitida para redirecionamento SSO:', currentPath)
        return
      }

      const sso = this.config && this.config.sso
      if (!sso || !sso.clientId || !sso.redirectUrl) {
        console.warn('SSO config incompleto. Redirecionamento abortado.')
        return
      }

      const query = new URLSearchParams({
        response_type: 'code',
        scope: 'openid',
        client_id: sso.clientId,
        redirect_uri: sso.redirectUrl,
      })

      const urlParams = new URLSearchParams(window.location.search)

      if (!urlParams.has('returnTo')) {
        window.location.href = `/authorize?${query.toString()}`
      } else {
        localStorage.clear()
      }
    },
    setMetaDataFromTemplate() {
      document.title = this.config.meta.title

      const descEl = document.querySelector('head meta[name="description"]')
      if (descEl) {
        descEl.setAttribute('content', this.config.meta.desc)
      } else {
        const newMeta = document.createElement('meta')
        newMeta.name = 'description'
        newMeta.content = this.config.meta.desc
        document.head.appendChild(newMeta)
      }

      if (this.config.meta.favicon) {
        let favicon = document.querySelector("link[rel~='icon']")
        if (!favicon) {
          favicon = document.createElement('link')
          favicon.rel = 'icon'
          document.head.appendChild(favicon)
        }
        const cacheBuster = `?v=${new Date().getTime()}`
        favicon.href = `${this.config.meta.favicon}${cacheBuster}`
      }
    },
  },
}
</script>

<style>
.fallback {
  background-color: var(--fallbackColor);
}

.input-show-pass {
  font-size: 15px;
  color: #999;
  display: flex;
  position: absolute;
  height: 100%;
  top: 0;
  right: 12px;
  padding: 0 5px;
  cursor: pointer;
  transition: background 0.4s;
}

.input-show-pass:hover {
  color: #a09569;
}

.backGround {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-width: 375px;
}

.secondary-input-theme {
  background-color: transparent;
  border-bottom: 1px solid white;
  border-top: 0px;
  font-size: var(--font-size-input-secondary, calc(0.85rem * 1.15));
  font-weight: var(--font-weight-p, 400);
  border-left: 0px;
  border-right: 0px;
  padding: 4px 2px;
  color: white;
  font-family: var(--font-family-p, Inter, sans-serif);
}

.secondary-input-theme:focus {
  outline: none;
}

.c-input {
  background-color: transparent;
  border-bottom: 1px solid white;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  padding: 4px 2px;
  color: white;
  width: 100%;
  font-size: var(--font-size-input, 1.15rem);
  font-family: var(--font-family-p, Inter, sans-serif);
  font-weight: var(--font-weight-p, 400);
}

.c-input:focus {
  outline: none;
  border-bottom: 2px solid var(--input-color);
}

.c-select {
  border-bottom: 2px solid white;
  max-height: 50px !important;
  overflow-y: auto;
  background: transparent;
  border-top: none;
  border-right: none;
  border-left: none;
  color: white;
  font-size: var(--font-size-input, 1.15rem);
}

.c-select:focus {
  outline: none;
  border-bottom: 2px solid var(--input-color);
  padding-right: 5px;
}

.c-input::placeholder,
.secondary-input-theme::placeholder {
  color: white;
  opacity: 0.7;
  font-size: 80%;
  font-family: var(--font-family-p, Inter, sans-serif);
  font-weight: var(--font-weight-p, 400);
}

.c-input::-ms-input-placeholder,
.secondary-input-theme::-ms-input-placeholder,
.c-input:-ms-input-placeholder,
.secondary-input-theme:-ms-input-placeholder {
  color: white;
  opacity: 0.7;
  font-size: 80%;
  font-family: var(--font-family-p, Inter, sans-serif);
  font-weight: var(--font-weight-p, 400);
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  color: white;
  background-color: transparent;
  transition: background-color 5000s ease-in-out 0s;
  -moz-text-fill-color: White;
  -webkit-text-fill-color: White;
}

::-webkit-scrollbar-track {
  background-color: #f4f4f4;
  border-radius: 4px;
  padding-left: 6px;
}

::-webkit-scrollbar {
  width: 16px;
  border-radius: 4px;
  background: #f4f4f4;
  cursor: grab !important;
  max-height: 70%;
}

::-webkit-scrollbar-thumb {
  background: #5c5c5c;
  border-radius: 4px;
  cursor: grab !important;
}

::-webkit-scrollbar-track {
  background-color: #f4f4f4;
  border-radius: 4px;
  padding-left: 6px;
}

::-webkit-scrollbar {
  width: 16px;
  border-radius: 4px;
  background: #f4f4f4;
  cursor: grab !important;
  max-height: 70%;
}

::-webkit-scrollbar-thumb {
  background: #5c5c5c;
  border-radius: 4px;
  cursor: grab !important;
}
</style>

<style lang="scss">
@import './assets/scss/style.scss';
</style>
